import { Button, Text } from "@kvix/ui";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    textAlign: "center",
    padding: "38px",
    margin: "auto",
    width: "100%",
  },
  dialogTitle: {
    whiteSpace: "pre-line",
    letterSpacing: "0",
    lineHeight: "44px",
  },
  dialogText: {
    whiteSpace: "pre-line",
    wordBreak: "break-word",
  },
  dialogActions: {
    justifyContent: "center",
    flexDirection: "column",
    padding: "0 10%",
  },
  dialogButtonClose: {
    width: "100%",
  },
}));

export const EmailUpdateConfirmationDialog: React.FC<{
  open: boolean;
  fullScreen: boolean;
  errors: string[];
  handleOpen: (value: boolean) => void;
}> = (props) => {
  const classes = useStyles(props);
  const isError = props.errors.length > 0;
  const { t, ready } = useTranslation(["account", "general"]);

  if (!ready) {
    return null;
  }

  return (
    <Dialog
      open={props.open}
      onClose={() => props.handleOpen(false)}
      fullScreen={props.fullScreen}
    >
      <div className={classes.dialogContainer}>
        <Text className={classes.dialogTitle} variant="h3">
          {isError
            ? t("general:errors.somethingWrongShort")
            : t("account.confirmEmailDialog.success")}
        </Text>
        <DialogContent style={{ margin: "12px 0" }}>
          <DialogContentText className={classes.dialogText}>
            {isError
              ? t("account.confirmEmailDialog.failedResult")
              : t("account.confirmEmailDialog.successfulResult")}
          </DialogContentText>
          {isError && <Alert severity="error">{props.errors[0]}</Alert>}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => props.handleOpen(false)}
            color="primary"
            variant="text"
            className={classes.dialogButtonClose}
          >
            {t("general:buttons.okay")}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
